<template>
<div class="search">
  <div class="order">
    <div class="head">
      <div class="items">
        <div class="ite">
          <div class="ite-left">系统唯一序号:</div>
          <div class="ite-right">{{ row.guid || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">报送类型:</div>
          <div class="ite-right">{{ appTypeObj[row.appType] || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">报送时间:</div>
          <div class="ite-right">{{ row.appTime || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">报送状态:</div>
          <div class="ite-right">{{ appStatusObj[row.appStatus] || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">物流企业代码:</div>
          <div class="ite-right">{{ row.logisticsCode || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">物流企业名称:</div>
          <div class="ite-right">{{ row.logisticsName || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">物流运单编号:</div>
          <div class="ite-right">{{ row.logisticsNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">运费:</div>
          <div class="ite-right">{{ row. freight || '0'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">保价费:</div>
          <div class="ite-right">{{ row. insuredFee|| '0'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">币制:</div>
          <div class="ite-right">{{  row.currency || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">件数:</div>
          <div class="ite-right">{{ row.packNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">电商企业代码:</div>
          <div class="ite-right">{{ row.ebcCode || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">电商企业名称:</div>
          <div class="ite-right">{{ row.ebcName || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">电商企业电话:</div>
          <div class="ite-right">{{ row.ebcTelephone || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">备注:</div>
          <div class="ite-right">{{ row.note || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">主要货物信息:</div>
          <div class="ite-right">{{ row.goodsInfo || '--'}}</div>
        </div>
      </div>
    </div>
  <div>
  </div>
  </div>
</div>
</template>
<script>
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
// import apiPath from '@config/api.json'
export default {
  components: {pagination},
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    appTypeObj: {
      type: Object,
      default: () => {}
    },
    appStatusObj: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      tableData: []
    }
  },
  created () {
    // this.getList()
  },
  methods: {
    // getList () {
    //   console.log('row', this.row)
    //   let data = {
    //     // 'companyName': this.row.info.companyName,
    //     companyNo: this.row.info.companyNo,
    //     searchNo: this.row.orderNo,
    //     'pageIndex': this.page.current,
    //     'pageSize': this.page.size
    //   }
    //   this.$ajax({
    //     method: 'post',
    //     url: `${apiPath.bigData.search.listDeclarationOrderItem}`,
    //     data: data
    //   }).then(res => {
    //     if (res.data) {
    //       debugger
    //     }
    //   })
    // }
  }
}
</script>
<style lang="scss" scoped>
.order {
  width: calc(100% - 40px);
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0);
  border: 1px solid rgba(37, 92, 152, 1);

  .head {
    padding: 28px 28px 0px;
    .items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;
      .ite {
        display: flex;
        width: 25%;
        .ite-left {
          width: 50%;
          text-align: right;
        }
        .ite-right {
          width: 50%;
          text-align: left;
          margin-left: 5px;
        }
      }
    }
  }
}

</style>
<style lang="scss">
.ux-filter-records {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 20px 35px 0px 0px;
    box-sizing: border-box;
    .filter {
      display: flex;
      flex-wrap: wrap;
      // div {
      //   margin-right: 18px;
      //   margin-bottom: 10px;
      // }
      .search {
        color: #ffffff;
        background: #1c8be2;
      }
    }
    .content-list {
      margin-top: 10px;
      flex: none;
      // min-height: 550px;
      .table {
        height: 100%;
        .el-table__header-wrapper {
          tr {
            th {
              height: 50px;
            }
          }
        }
        .el-table__body-wrapper {
          tr {
            td {
              height: 50px;
            }
          }
        }
        .el-loading-mask {
          /* background: rgba(0, 0, 0, 0.8); */
          .el-loading-spinner {
            font-size: 24px;
          }
        }
        .text {
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .ux-dark-el-table {
        display: flex;
        flex-direction: column;
        border: 1px solid #2d6bab;
        background-color: transparent;
        table {
        thead {
          tr {
            background: rgba(24, 127, 215, 0.1) !important;
            &:last-child {
              td {
                border-bottom: none;
              }
            }
            th {
              padding: 0;
              border-color: #2d6bab !important;
              background: rgba(24, 127, 215, 0.3) !important;
              &:last-child {
                border-right: none;
              }
              .cell {
                font-size: 16px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color:#fff;
                // background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
                // background-clip: text;
                // -webkit-text-fill-color: transparent;
              }
            }
            td {
              padding: 0;
              font-size: 14px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: #ffffff;
              border-color: #2d6bab;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
        }
        td.el-table__cell{
          border-bottom: 1px solid #2d6bab;
        }
        &::before {
          display: none;
        }
        // tbody row hover
        &.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
          background: rgba(24, 127, 215, 0.2);
        }
        // 多级表头
        &.el-table--group::after,
        // 带边框表格
        &.el-table--border::after {
          content: unset;
        }
        .el-table__body-wrapper {
          flex: 1 1;
          table {
            height: 100%;
          }
        }
        .el-table__footer-wrapper tbody td.el-table__cell {
          font-size: 16px;
          background-color: transparent;
        }
      }
    }
    .pages {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 28px;
      font-size: 16px;
      font-weight: 400;
      color: #fff;
    }
  }</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/components/Waybill.vue